import { createContext } from "react";

//todo change default
export const FooterContext = createContext({default: "/"});